"use client";

import Link from "next/link";
import { ArrowRight } from "lucide-react";

type ProjectCtaLinkProps = {
	href: string;
	external?: boolean;
};

const baseClassName =
	"group/project-cta inline-flex w-fit items-center gap-3 overflow-hidden rounded-[1rem] border border-white/12 bg-[linear-gradient(180deg,rgba(255,255,255,0.04),rgba(255,255,255,0.02))] px-4 py-2 text-[0.95rem] text-zinc-100 shadow-[inset_0_1px_0_rgba(255,255,255,0.08)] transition duration-300 hover:border-white/18 hover:bg-white/[0.04]";

function ProjectCtaInner() {
	return (
		<>
			<span>View Project</span>
			<span className="inline-flex h-8 w-8 items-center justify-center rounded-[0.7rem] border border-white/10 bg-white/[0.05] text-zinc-100 transition duration-300 group-hover/project-cta:border-white/14 group-hover/project-cta:bg-white/[0.06]">
				<ArrowRight className="h-4 w-4 transition duration-300 group-hover/project-cta:translate-x-0.5" />
			</span>
		</>
	);
}

export default function ProjectCtaLink({
	href,
	external = false,
}: ProjectCtaLinkProps) {
	const sharedProps = {
		className: baseClassName,
	};

	if (external) {
		return (
			<a
				href={href}
				target="_blank"
				rel="noopener noreferrer"
				className={`${baseClassName} cursor-ne-resize cursor-apple-ne-resize`}
			>
				<ProjectCtaInner />
			</a>
		);
	}

	return (
		<Link href={href} {...sharedProps}>
			<ProjectCtaInner />
		</Link>
	);
}
